import { Link } from "@/shared";
import {
  Breadcrumb,
  BreadcrumbAction,
  BreadcrumbItem,
} from "@dafiti/closet-ui";

import type { CatalogMetaResponse } from "../../../types/catalog.type";

type Props = {
  breadcrumb?: CatalogMetaResponse["breadcrumbs"];
};

export function CatalogBreadcrumb({ breadcrumb }: Readonly<Props>) {
  if (!breadcrumb?.length) return null;

  return (
    <div className="mb-2">
      <Breadcrumb data-testid="catalog-breadcrumb">
        {breadcrumb.map((item, index) => (
          <BreadcrumbItem
            key={item.key}
            isLast={index === breadcrumb.length - 1}
          >
            {item.url ? (
              <BreadcrumbAction as={Link} useRouterLink href={item.url}>
                {item.name}
              </BreadcrumbAction>
            ) : (
              <BreadcrumbAction>{item.name}</BreadcrumbAction>
            )}
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </div>
  );
}
